import { render } from "./CleaningIndex.vue?vue&type=template&id=0385bc8c&scoped=true"
import script from "./CleaningIndex.vue?vue&type=script&lang=js"
export * from "./CleaningIndex.vue?vue&type=script&lang=js"

import "./CleaningIndex.vue?vue&type=style&index=0&id=0385bc8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0385bc8c"]])

export default __exports__